import { render, staticRenderFns } from "./PrePurchaseRunnitTokensBtn.vue?vue&type=template&id=24d90ca2&scoped=true"
import script from "./PrePurchaseRunnitTokensBtn.vue?vue&type=script&lang=ts"
export * from "./PrePurchaseRunnitTokensBtn.vue?vue&type=script&lang=ts"
import style0 from "./PrePurchaseRunnitTokensBtn.vue?vue&type=style&index=0&id=24d90ca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d90ca2",
  null
  
)

export default component.exports